import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { shallow } from 'zustand/shallow'
import moment from 'moment'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

const ViewModel = () => {
  const { id } = useParams<{ page: string; id: string }>()
  const { selected, edit, getOne, openProject, closeProject } = useProjectStore(
    state => ({
      selected: state.selected,
      getOne: state.getOne,
      edit: state.edit,
      openProject: state.open,
      closeProject: state.close,
    }),
    shallow
  )
  const [hasEdit, setHasEdit] = useState(false)
  const [formState, setFormState] = useState({
    startJobDate: '',
    endJobDate: '',
    totalExpectPile: '0',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({})
  
  const MIN_DATE = moment('2015-01-01')

  const validateDate = (date: any, fieldName: string): string => {
    if (!date) return ''
    const dateMoment = moment(date)
    if (!dateMoment.isValid()) return ''
    if (dateMoment.isBefore(MIN_DATE, 'day')) {
      return 'วันที่ต้องไม่น้อยกว่าวันที่ 1 มกราคม 2015'
    }
    return ''
  }

  const onChangeFormState = (key: string, value: any) => {
    setFormState({
      ...formState,
      [key]: value,
    })
    setHasEdit(true)
    
    // Validate date fields
    if (key === 'startJobDate' || key === 'endJobDate') {
      const error = validateDate(value, key)
      setFormErrors(prev => ({
        ...prev,
        [key]: error,
      }))
    }
  }

  const handleData = () => {
    setFormState({
      // @ts-ignore
      startJobDate: selected?.startJobDate ? moment(selected?.startJobDate).tz('Asia/Bangkok') : '',
      // @ts-ignore
      endJobDate: selected?.endJobDate ? moment(selected?.endJobDate).tz('Asia/Bangkok') : '',
      totalExpectPile: selected?.totalExpectPile ? selected?.totalExpectPile.toString() : '0',
    })
  }

  const onSubmit = () => {
    if (hasEdit) {
      // Validate dates
      const startDateError = validateDate(formState.startJobDate, 'startJobDate')
      const endDateError = validateDate(formState.endJobDate, 'endJobDate')
      
      const errors: { [key: string]: string } = {}
      if (startDateError) errors.startJobDate = startDateError
      if (endDateError) errors.endJobDate = endDateError
      
      setFormErrors(errors)
      
      // If there are validation errors, don't submit
      if (Object.keys(errors).length > 0) {
        Swal.fire({
          title: 'กรุณากรอกข้อมูลให้ถูกต้อง',
          html: Object.values(errors).map(error => `<p>${error}</p>`).join(''),
          icon: 'error',
          confirmButtonText: 'ยืนยัน',
        })
        return
      }
      
      setIsSubmitting(true)
      edit(id ? parseInt(id) : 0, {
        startJobDate:
          moment(formState.startJobDate).isValid() && formState.startJobDate !== ''
            ? moment(formState.startJobDate).tz('Asia/Bangkok').toISOString()
            : undefined,
        endJobDate:
          moment(formState.endJobDate).isValid() && formState.endJobDate !== ''
            ? moment(formState.endJobDate).tz('Asia/Bangkok').toISOString()
            : undefined,
        totalExpectPile: parseInt(formState.totalExpectPile),
      }).then(({ success, data }) => {
        if (!success) {
          toast.error(data)
          setIsSubmitting(false)
        } else {
          toast.success('บันทึกข้อมูลสำเร็จ')
          getOne(id ? parseInt(id) : 0)
          setHasEdit(false)
          setIsSubmitting(false)
          setFormErrors({})
        }
      })
    }
  }
  const onOpenproject = () => {
    if (selected) {
      Swal.fire({
        title: 'ยืนยันการเปิดโครงการ',
        text: 'คุณต้องการเปิดโครงการนี้ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(result => {
        if (result.isConfirmed) {
          openProject(selected.id).then(({ success, data }) => {
            if (!success) {
              toast.error(data)
            } else {
              toast.success('เปิดโครงการสำเร็จ')
              getOne(selected.id)
            }
          })
        }
      })
    }
  }
  const onCloseproject = () => {
    if (selected) {
      Swal.fire({
        title: 'ยืนยันการปิดโครงการ',
        text: 'คุณต้องการปิดโครงการนี้ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(result => {
        if (result.isConfirmed) {
          closeProject(selected.id).then(({ success, data }) => {
            if (!success) {
              toast.error(data)
            } else {
              toast.success('ปิดโครงการสำเร็จ')
              getOne(selected.id)
            }
          })
        }
      })
    }
  }
  useEffect(() => {
    handleData()
    // eslint-disable-next-line
  }, [selected])

  return {
    isSubmitting,
    hasEdit,
    formState,
    formErrors,
    projectState: selected.projectState,
    onChangeFormState,
    onSubmit,
    onOpenproject,
    onCloseproject,
  }
}

export default ViewModel
